import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PageHeader } from "@/components/PageHeader";
import { ProjectForm } from "@/features/projects/ProjectForm";
import { api } from "@/lib/api";
import type { ProjectCreateInput } from "@axorial/shared";

export const Route = createFileRoute("/projects/new")({
  component: NewProjectPage,
});

function NewProjectPage() {
  const navigate = useNavigate();
  const qc = useQueryClient();

  const create = useMutation({
    mutationFn: (input: ProjectCreateInput) => api.post<{ id: string }>("/projects", input),
    onSuccess: ({ id }) => {
      qc.invalidateQueries({ queryKey: ["projects"] });
      navigate({ to: "/projects/$projectId", params: { projectId: id } });
    },
  });

  return (
    <div className="space-y-6 max-w-2xl">
      <PageHeader
        eyebrow="proyectos"
        title="Nuevo proyecto"
        subtitle="Configura los datos básicos. Podrás añadir links, miembros y documentos después de crearlo."
      />
      <ProjectForm
        mode="create"
        onSubmit={(input) => create.mutate(input)}
        onCancel={() => navigate({ to: "/projects" })}
        submitting={create.isPending}
      />
    </div>
  );
}
